import { styled, TextField } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const ListContainer = styled.div`
  height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.xxxs};

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 0 ${theme.spacing.inline.nano};
      height: 40vh;
    }
  `}

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.neutralColor.high.medium};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutralColor.high.dark};
    border-radius: ${({ theme }) => theme.border.radius.sm};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.neutralColor.low.light};
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.xxxs};

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-flow: row wrap;
      padding: 0 ${theme.spacing.inline.nano};
    }
  `}
`;

export const SearchField = styled(TextField)`
  width: 50%;
  margin: 0;

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const Switch = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxxs};

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-flow: row wrap;
      padding: ${theme.spacing.inline.nano} 0;
    }
  `}
`;
